
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cont/resetare-parola",
      function () {
        return require("private-next-pages/cont/resetare-parola.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cont/resetare-parola"])
      });
    }
  